import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=cd7247e4&scoped=true&"
import script from "./Tree.vue?vue&type=script&setup=true&lang=js&"
export * from "./Tree.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Tree.vue?vue&type=style&index=0&id=cd7247e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7247e4",
  null
  
)

export default component.exports